import { FC } from "react";

const TermsOfUse: FC = () => {
  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-2xl font-semibold">Условия использования</h2>
      <div className="bg-white rounded-2xl shadow p-6">
        <div className="prose max-w-none">
          <p className="font-semibold mb-4">
            Условия использования сайта «КЦ Авто»
          </p>
          <p className="mb-4">
            Настоящие Условия использования сайта (далее – Условия) регулируют
            порядок использования сайта «КЦ Авто», расположенного в сети
            Интернет по адресу kcsib.ru (далее – Сайт), принадлежащего
            Индивидуальному предпринимателю Боровикову Григорию Владимировичу
            (далее – Продавец). Перед использованием Сайта внимательно
            ознакомьтесь с настоящими Условиями.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            1. Предмет Условий
          </h3>
          <p className="mb-2">
            1.1. Настоящие Условия определяют порядок доступа и использования
            Сайта, а также регулируют отношения между Продавцом и пользователями
            Сайта (далее – Покупатели) в части оформления предварительного
            резерва на автозапчасти.
          </p>
          <p className="mb-2">
            1.2. Сайт представляет собой информационную площадку, содержащую
            каталог автозапчастей, предназначенную исключительно для
            ознакомления Покупателей с ассортиментом, ценами и характеристиками
            товаров, а также для предоставления возможности оформления
            предварительного резерва товаров.
          </p>
          <p className="mb-4">
            1.3. Информация, представленная на Сайте, не является публичной
            офертой в смысле статьи 437 Гражданского кодекса Российской
            Федерации. Оформление предварительного резерва через Сайт не влечет
            за собой возникновения у Продавца обязанности по заключению договора
            купли-продажи дистанционным способом. Договор купли-продажи
            заключается исключительно в торговой точке Продавца после
            подтверждения наличия зарезервированных товаров и их оплаты
            Покупателем.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            2. Порядок оформления предварительного резерва
          </h3>
          <p className="mb-2">
            2.1. Для оформления предварительного резерва на Сайте Покупателю
            необходимо выбрать интересующие его товары и добавить их в
            «Корзину».
          </p>
          <p className="mb-2">
            2.2. После формирования «Корзины» Покупатель заполняет предложенную
            форму, указывая свои контактные данные (имя, номер телефона, адрес
            электронной почты) и выбирает торговую точку Продавца, в которой
            планирует получить и оплатить заказ.
          </p>
          <p className="mb-2">
            2.3. Оформление предварительного резерва считается завершенным после
            подтверждения Покупателем своего намерения зарезервировать товары на
            соответствующей странице Сайта.
          </p>
          <p className="mb-2">
            2.4. После оформления предварительного резерва Продавец обрабатывает
            запрос и информирует Покупателя о возможности резервирования
            (подтверждение резерва, необходимость уточнения деталей и т.п.) по
            указанному номеру телефона или адресу электронной почты. Данное
            уведомление не является подтверждением заключения договора
            купли-продажи.
          </p>
          <p className="mb-4">
            2.5. Предварительный резерв товара действует в течение 24 часов с
            момента уведомления Покупателя Продавцом о возможности
            резервирования. По истечении указанного срока, если Покупатель не
            обратился в выбранную торговую точку для получения и оплаты товара,
            предварительный резерв аннулируется.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            3. Информация о ценах и наличии товаров
          </h3>
          <p className="mb-2">
            3.1. Цены на товары, представленные на Сайте, носят исключительно
            информационный характер и могут отличаться от фактических цен в
            торговой точке Продавца.
          </p>
          <p className="mb-2">
            3.2. Фактическая цена товара, действующая на момент заключения
            договора купли-продажи, подлежит уточнению Покупателем
            непосредственно в выбранной торговой точке Продавца перед оплатой.
          </p>
          <p className="mb-4">
            3.3. Информация о наличии товаров на Сайте отражает предполагаемое
            наличие и может не соответствовать фактическому наличию в торговой
            точке на момент обращения Покупателя.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            4. Оплата и получение товара
          </h3>
          <p className="mb-2">
            4.1. Оплата зарезервированного товара производится Покупателем
            исключительно в выбранной им торговой точке Продавца при получении
            товара.
          </p>
          <p className="mb-2">
            4.2. Доступные способы оплаты в торговой точке могут отличаться и
            уточняются непосредственно в торговой точке.
          </p>
          <p className="mb-4">
            4.3. Получение зарезервированного товара осуществляется Покупателем
            лично или его уполномоченным представителем в выбранной торговой
            точке Продавца после полной оплаты его стоимости в соответствии с
            ценами, действующими в торговой точке на момент оплаты.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            5. Права и обязанности сторон
          </h3>
          <p className="mb-2 font-semibold">5.1. Продавец вправе:</p>
          <ul className="list-disc pl-6 mb-2">
            <li>
              В любое время изменять содержание, функциональность и
              пользовательский интерфейс Сайта.
            </li>
            <li>Отказать в предварительном резерве без объяснения причин.</li>
            <li>
              Информировать Покупателя о статусе его предварительного резерва.
            </li>
          </ul>
          <p className="mb-2 font-semibold">5.2. Покупатель обязуется:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>
              Использовать Сайт в соответствии с настоящими Условиями и
              действующим законодательством РФ.
            </li>
            <li>
              Предоставлять достоверную информацию при оформлении
              предварительного резерва.
            </li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            6. Ответственность сторон
          </h3>
          <p className="mb-2">
            6.1. Продавец не несет ответственности за неточности, допущенные
            Покупателем при оформлении предварительного резерва.
          </p>
          <p className="mb-2">
            6.2. Продавец не несет ответственности за временную
            неработоспособность Сайта или его отдельных функций.
          </p>
          <p className="mb-4">
            6.3. Поскольку договор купли-продажи заключается и оплата
            производится непосредственно в торговой точке, Продавец не несет
            ответственности за качество товара, его комплектность и соответствие
            описанию до момента заключения договора купли-продажи и передачи
            товара Покупателю. Все вопросы, связанные с качеством товара,
            решаются в соответствии с законодательством РФ после заключения
            договора купли-продажи в торговой точке.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            7. Персональные данные
          </h3>
          <p className="mb-2">
            7.1. Предоставляя свои персональные данные при оформлении
            предварительного резерва на Сайте, Покупатель дает согласие на их
            обработку Продавцом в целях обработки запроса на резервирование и
            информирования Покупателя о его статусе.
          </p>
          <p className="mb-4">
            7.2. Обработка персональных данных осуществляется Продавцом в
            соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О
            персональных данных» и Политикой конфиденциальности, размещенной на
            Сайте.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            8. Интеллектуальная собственность
          </h3>
          <p className="mb-4">
            8.1. Все материалы, размещенные на Сайте, включая тексты, графические
            изображения, логотипы, являются интеллектуальной собственностью
            Продавца или используются им на законных основаниях. Любое
            копирование, распространение или иное использование указанных
            материалов без предварительного письменного согласия Продавца
            запрещено.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">9. Прочие условия</h3>
          <p className="mb-2">
            9.1. Настоящие Условия могут быть изменены Продавцом в одностороннем
            порядке без предварительного уведомления Покупателей. Новая редакция
            Условий вступает в силу с момента ее размещения на Сайте.
          </p>
          <p className="mb-2">
            9.2. По вопросам, не урегулированным настоящими Условиями, стороны
            руководствуются действующим законодательством Российской Федерации.
          </p>
          <p className="mb-4">
            9.3. В случае возникновения споров и разногласий между Продавцом и
            Покупателем, стороны обязуются принять меры для их урегулирования
            путем переговоров. При невозможности разрешения спора путем
            переговоров, он подлежит рассмотрению в суде в соответствии с
            законодательством Российской Федерации.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            10. Информация о Продавце
          </h3>
          <p className="mb-1">
            Индивидуальный предприниматель Боровиков Григорий Владимирович
          </p>
          <p className="mb-1">ИНН: 420524372176</p>
          <p className="mb-1">ОГРНИП: 310420518800049</p>
          <p className="text-gray-600 text-sm mt-4">
            Дата публикации: 02 апреля 2025 г.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;